import store from '@/store'

export const isUnimed = () => {
  return store.state.login.operadora.unimed === 1
}

export const searchMenu = (arr, name) => {
  for (let i = 0; i < arr.length; i++) {
    const obj = arr[i]
    if (obj.routerName === name) {
      return {
        status: true,
        menu: obj
      }
    } else if (obj.childs && searchMenu(obj.childs, name).status) {
      return {
        status: true,
        menu: obj
      }
    }
  }
  return {}
}
export const searchMenuToId = (arr, routerName) => {
  for (let i = 0; i < arr.length; i++) {
    const obj = arr[i]
    if (obj.routerName === routerName) {
      return {
        status: true,
        menu: obj
      }
    } else if (obj.childs && searchMenu(obj.childs, routerName).status) {
      return {
        status: true,
        menu: obj
      }
    }
  }
  return {}
}
